import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { StaffProvider } from '../../providers/staff/staff';
import { ToastProvider } from '../../providers/toast/toast';
import { AttendancePage } from '../attendance/attendance';
import { ExtraProvider } from '../../providers/extra/extra';
import { MyStaffTabsPage } from '../my-staff-tabs/my-staff-tabs';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-staff-detail',
  templateUrl: 'staff-detail.html',
})
export class StaffDetailPage {

	staff: any;
	reviews = [];
  associated = false;
  showData = false;
  isMyReview = false;
  temp = {
    rating: "0",
    remarks: ""
  };
  review = {
    rating: "0",
    remarks: ""
  };
  isReviewEdited = false;
  isNotifyEnabled = false;

  constructor(public navCtrl: NavController, 
    private translate: TranslateService,
    public navParams: NavParams, 
    private staffProvider: StaffProvider, 
    private toast: ToastProvider, 
    private extra: ExtraProvider,
    private ref: ChangeDetectorRef,
    private util: UtilService
    ) {
  	this.staff = this.navParams.get("data");

  	staffProvider.getReviews(this.staff.id).then(val => {
			if(val.status == "success"){
  			this.reviews = val.data;
  		}else{
  			this.toast.presentToast(val.message);
      }
      this.showData = true;
      this.isAssociated(JSON.parse(this.staff.work_location));
      this.myReview(this.reviews);
      this.notifyEnabled(this.staff.notify_to);
      this.ref.detectChanges();
  	});
  }

  isAssociated(workLocation: any){
    if(workLocation){
      this.extra.getUserDetails().then(user => {
        workLocation.forEach(val => {
          if(val.flat_no == user.flat_no){
            this.associated = true;
          }
        });
        this.showData = true;
      });
    }
  }

  myReview(reviews: any){
    this.extra.getUserDetails().then(user => {
      reviews.forEach((val, index) => {
        if(val.display_name == user.flat_no){
          let temp = val;
          this.reviews.splice(index, 1);
          this.reviews.splice(0, 0, temp);
          this.isMyReview = true;
        }
      });
      console.log(this.reviews);
      this.ref.detectChanges();
    });
  }

  editReview(review: any){
    this.review = review;
    this.temp = Object.assign({}, review);
    this.isMyReview = false;
    this.isReviewEdited = true;
    this.reviews.splice(0, 1);
  }

  starClicked(num: number){
    num++;
    console.log(num);
    this.review.rating = num.toString();
    console.log(this.review);
  }

  nonStarClicked(num: number){
    let temp = +this.review.rating;
    temp = temp + num + 1;
    this.review.rating = temp.toString();
    console.log(this.review);
  }

  submitReview(){
    this.extra.getUserDetails().then(user => {  
      let data = {
        anonymousName: user.flat_no,
        rating: this.review.rating,
        remarks: this.review.remarks,
        staff_id: this.staff.id,
        display_name: user.flat_no
      }
      this.staffProvider.submitReview(data).then(val => {
        if(val.status == "success"){
          this.toast.presentToast("Review added");
          this.reviews.splice(0,0,data);
          this.isMyReview = true;
        }else {
          this.toast.presentToast(val.message);
        }
      })
    });
  }

  cancelReview(){
    this.isReviewEdited = false;
    this.isMyReview = true;
    console.log(this.temp);
    this.reviews.unshift(this.temp);
  }

  release(){
    this.staffProvider.release(this.staff.id).then(val => {
      if(val.status == "success"){
        this.toast.presentToast("Staff realeased");
        if (typeof this.navParams.get("parent").refreshStaff === "function") { 
          this.navParams.get("parent").refreshStaff();
        }
        this.navCtrl.pop();
      }
    });
  }

  associate(){
    this.staffProvider.associate(this.staff.id).then(val => {
      if(val.status == "success"){
        this.toast.presentToast("Staff associated");
      	this.navCtrl.push(
          MyStaffTabsPage
        ).then(() =>  {
          this.util.clearNavStack(this.navCtrl);
        });
      }
    });
  }

  notifyEnabled(notifyTo: string){
    if(notifyTo && notifyTo != "[]"){
      try{
        console.log(notifyTo);
        this.extra.getUserDetails().then(val => {
          JSON.parse(notifyTo).forEach(id => {
            if(val.id == id){
              this.isNotifyEnabled = true;
            }
          });
        });
      }catch(e){
        this.isNotifyEnabled = false;
      }
    }
  }

  toggleNotification(){
    if(this.isNotifyEnabled){
      this.staffProvider.notification(this.staff.id, 0).then(val => {
        if(val.status == "success"){
          this.isNotifyEnabled = false;
          try {
            this.extra.getUserDetails().then(val => {
              this.staff.notify_to = "[]";
            });
          } catch (error) {
            console.log(error);
          }
        }
        this.toast.presentToast(val.data);
      });
    }else{
      this.staffProvider.notification(this.staff.id, 1).then(val => {
        this.isNotifyEnabled = true;
        if(val.status == "success"){
          try {
            this.extra.getUserDetails().then(val => {
              let notifyTo = JSON.parse(this.staff.notify_to);
              notifyTo.push(val.id);
              this.staff.notify_to = JSON.stringify(notifyTo);
              console.log(this.staff.notify_to);
              
            });
          } catch (error) {
            console.log(error);
          }
        }
        this.toast.presentToast(val.data);
      });
    }
  }

  attendance(){
    this.navCtrl.push(AttendancePage, {
      id: this.staff.id,
      name: this.staff.name
    });
  }

  getObject(s : string){
    return JSON.parse(s);
  }

  getAvgRating(staff){
    try {
      return +this.getObject(staff.avg_rating)[0].average_rating;
    } catch (error) {
      return 0;
    }
  }

  getRating(rating: string){
    if(!(rating && parseInt(rating) <= 5)){
      rating = "0"
    }
  	return Array(+rating);
  }

  getNonRating(rating: string){
    if(!(rating && parseInt(rating) <= 5)){
      rating = "5"
    }
    return Array(5 - (+rating));
  }


  showStaffPopup(data: any){
    if(data > 1){
      this.toast.presentToast('Working in '+ data +' units');
    }else if(data == 1){
      this.toast.presentToast('Working in '+ data +' unit');
    }else{
      this.toast.presentToast('no associate unit found');
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad StaffDetailPage');
  }
  ionViewWillUnload() {
    if (typeof this.navParams.get("parent").refreshStaff === "function") { 
      this.navParams.get("parent").refreshStaff();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/staff-detail/staff-detail.ts